import './details/details';
import './details/details-package';
import './details/details-accommodation';
import './details/details-fix';
import './details/details-combined';

// ALERT BOOKING START
window.alertBookingTimeout = {};

window.setAlertBooking = ($target) => {
    const $unit = $target.closest('.unit');
    const unitId = $unit.attr('data-unitid');
    const $alertBooking = $unit.find('.alert-booking');

    $alertBooking.addClass('active');
    const alertTimeout = setTimeout(() => {
        $alertBooking.removeClass('active');
    }, 4000);

    window.alertBookingTimeout[unitId] = alertTimeout;
}

$('.alert-booking [data-close]').on('click', e => {
    const $target = $(e.currentTarget);
    const $unit = $target.closest('.unit');
    const unitId = $unit.attr('data-unitid');
    const $alertBooking = $target.closest('.alert-booking');

    $alertBooking.removeClass('active');

    if (window.alertBookingTimeout[unitId]) {
        clearTimeout(window.alertBookingTimeout[unitId]);
        window.alertBookingTimeout[unitId] = 0;
    }
});
// ALERT BOOKING END